"use client";

import { BookOpen, RotateCcw, Clock, TrendingUp } from "lucide-react";
import SegmentCard from "../SegmentCard";
import { track } from "../../../lib/analytics";

// "For your situation" row. Four audience cards mapped to the highest
// ranked student segments. Each card links to /signup with a tagged
// segment query so signup funnels remain attributable.
const SEGMENTS = [
  {
    key: "first_time",
    title: "First-Time Test Takers",
    Icon: BookOpen,
    pitch: "You have a test date and a vague sense of dread. Maren turns that into a week one of work: which resource to open tonight, how long to spend, what to log when you are done.",
    cta: "Start week one",
  },
  {
    key: "retaker",
    title: "Retakers",
    Icon: RotateCcw,
    pitch: "You already know the content. You already studied. Something else cost you points. Retake Mode imports your first-attempt sub-scores and builds a different mix from there.",
    cta: "Open Retake Mode",
    highlight: true,
    highlightLabel: "Built for retakers",
  },
  {
    key: "non_trad",
    title: "Non-Trads and Time-Strapped",
    Icon: Clock,
    pitch: "Ninety minutes tonight, two on Saturday, a full-time job. Maren plans against the hours you actually have, not the 12-week template no working adult can hold to.",
    cta: "Fit it into my week",
  },
  {
    key: "plateau",
    title: "Plateaued in the Mid-Range",
    Icon: TrendingUp,
    pitch: "Your score stalled and you have ruled out laziness. You are studying the same things the same way. Maren names the three to five things that keep costing points, and works them.",
    cta: "Break the plateau",
  },
];

export default function SegmentRow() {
  return (
    <section className="py-20 sm:py-24 bg-white dark:bg-maren-charcoal border-t border-maren-sage/30 dark:border-maren-sage/20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-maren-green dark:text-maren-gold">
            For your situation
          </p>
          <h2 className="mt-4 font-display font-medium tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.15] text-maren-charcoal dark:text-maren-stone">
            Wherever you are with the MCAT, Maren meets you there.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {SEGMENTS.map((s) => (
            <SegmentCard
              key={s.key}
              Icon={s.Icon}
              title={s.title}
              pitch={s.pitch}
              cta={s.cta}
              href={`/signup?segment=${s.key}`}
              highlight={s.highlight}
              highlightLabel={s.highlightLabel}
              onCtaClick={() => track({ name: "cta_click", props: { location: `segment_${s.key}` } })}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
